import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  subtext?: string;
  href?: string;
  className?: string;
  size?: 'sm' | 'md';
}
export const CTAButton = memo(function CTAButton({
  text,
  subtext,
  href,
  className = '',
  size = 'md'
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (!href) {
      e.preventDefault();
      document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const isSmall = size === 'sm';
  const ButtonContent = <motion.div whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`relative w-full group ${className}`} data-id="element-45">
      <div className={`absolute -inset-1 bg-gradient-to-r from-red-600 to-orange-500 rounded-xl blur ${isSmall ? 'opacity-50' : 'opacity-70'} group-hover:opacity-100 transition duration-200`} data-id="element-46"></div>
      <button onClick={handleClick} className={`relative w-full flex flex-col items-center justify-center bg-gradient-to-b from-red-500 to-red-700 border-b-4 border-red-900 rounded-xl shadow-2xl text-white font-black uppercase tracking-wide hover:from-red-400 hover:to-red-600 transition-all ${isSmall ? 'px-4 py-3 text-base md:text-lg' : 'px-6 py-4 text-xl md:text-2xl'}`} data-id="element-47">
        <div className="flex items-center gap-2 text-center" data-id="element-48">
          {text}
          <ArrowRightIcon className={isSmall ? 'w-5 h-5 animate-bounce-x' : 'w-6 h-6 animate-bounce-x'} data-id="element-49" />
        </div>
        {subtext && <span className={`font-medium text-red-100 mt-1 normal-case tracking-normal ${isSmall ? 'text-xs md:text-sm' : 'text-sm md:text-base'}`} data-id="element-50">
            {subtext}
          </span>}
      </button>
    </motion.div>;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-51">
        {ButtonContent}
      </a>;
  }
  return ButtonContent;
});